export default __webpack_public_path__ + "cbe60f11d6a261bf043e8799bd5742e8.png";